<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  export let formData = {
    email: '',
    password: '',
    user_type_id: 'client'
  }
  export let loading = false
  export let mode: 'create' | 'edit' = 'create'

  const dispatch = createEventDispatcher()
</script>

<div class="space-y-5">
  <div>
    <label class="block text-xs font-bold text-indigo-200 uppercase tracking-wider mb-2">Email</label>
    <input 
      type="email"
      bind:value={formData.email}
      class="w-full px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-white focus:ring-2 focus:ring-pink-500/50 focus:border-pink-500/50 transition-all outline-none placeholder-white/20"
      placeholder="usuario@ejemplo.com"
    />
  </div>
  
  <div>
    <label class="block text-xs font-bold text-indigo-200 uppercase tracking-wider mb-2">
      {mode === 'create' ? 'Contraseña' : 'Nueva Contraseña (Opcional)'}
    </label>
    <input 
      type="password"
      bind:value={formData.password}
      class="w-full px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-white focus:ring-2 focus:ring-pink-500/50 focus:border-pink-500/50 transition-all outline-none placeholder-white/20"
      placeholder="••••••••"
    />
  </div>
</div>

<div class="flex justify-end gap-3 mt-10">
  <button 
    on:click={() => dispatch('cancel')}
    class="px-6 py-3 text-indigo-200/60 hover:text-white transition-colors font-medium"
  >
    Cancelar
  </button>
  <button 
    on:click={() => dispatch('submit')}
    disabled={loading}
    class="group px-6 py-3 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 hover:from-pink-400 hover:via-purple-400 hover:to-indigo-400 text-white rounded-xl font-bold shadow-lg shadow-purple-500/30 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none relative overflow-hidden"
  >
    <div class="absolute inset-0 bg-white/20 group-hover:translate-x-full transition-transform duration-700 -skew-x-12 -translate-x-full"></div>
    <span class="relative z-10">{loading ? 'Guardando...' : 'Guardar'}</span>
  </button>
</div>
